module.exports = __webpack_public_path__ + "static/testimonial-4-836aacdd25c2cc884349602711a956ca.png";